const config = {
  clientShortName: 'fanatiz',
  title: 'Fanatiz',
  email: 'info@toolboxtve.com',
  projectId: 'fanatiz_unified'
}

export default config;
